module.exports = __webpack_public_path__ + "static/media/cross.b23a7a22.svg";